export const jobTitles = [
  'IT',
  'Marketing',
  'Sales',
  'L&D',
  'Finance',
  'Operations',
  'R&D',
  'Product',
  'Education institution',
  'HR',
  'Other',
];
